module.exports = __webpack_public_path__ + "static/img/left_ico.938fc151.jpg";